export default "__VITE_ASSET__55390cc0__"